const KEY = "affinity.ref";
const LEADER_KEY = "affinity.deckLeader";
const TTL = 30 * 24 * 3600 * 1000;

export const setReferrer = (name, code) => localStorage.setItem(KEY, JSON.stringify({ name, code, ts: Date.now() }));

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && Date.now() - v.ts <= TTL ? v : null;
  } catch (_) {
    return null;
  }
};

export const getReferrer = () => {
  const v = read();
  return v ? (v.code ? `${v.name} (${v.code})` : v.name) : null;
};
export const getReferrerName = () => read()?.name || null;
export const getReferrerCode = () => read()?.code || null;

export const getDeckLeader = () => localStorage.getItem(LEADER_KEY) || "";
export const setDeckLeader = (slug) => (slug ? localStorage.setItem(LEADER_KEY, slug) : localStorage.removeItem(LEADER_KEY));
